import workspaceQuery from '../../../graphql/queries/product/LotAttributeConfigWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/product/LotAttributeConfigListQuery.graphql';
import instanceQuery from '../../../graphql/queries/product/LotAttributeConfigQuery.graphql';
import defaultQuery from '../../../graphql/queries/product/LotAttributeConfigDefault.graphql';
import mutationQuery from '../../../graphql/mutations/product/LotAttributeConfigMutation.graphql';
import fragment from '../../../graphql/fragments/product/LotAttributeConfigFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const LotAttribute: EntityType = {
  type: 'LotAttributeConfig',
  title: 'Lot Attributes',
  formTitle: 'Lot Attribute',
  formUrl: '/Products/StockControl/LotAttribute/Details/',
  workspaceUrl: '/Products/StockControl/LotAttribute/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  fragment,
  screenReference: 'PRODUCTS_STOCK_CONTROL_LOT_ATTRIBUTES',
};

export default LotAttribute;
